import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { documentId }: Boundaries["removeAttachedDocument"]["request"],
): State {
  const index = state.findIndex((req) => req.documentId === documentId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { documentId, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { documentId, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { documentId }: Boundaries["removeAttachedDocument"]["success"],
): State {
  const index = state.findIndex((req) => req.documentId === documentId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { documentId, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { documentId, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { documentId }: Boundaries["removeAttachedDocument"]["failure"],
): State {
  const index = state.findIndex((req) => req.documentId === documentId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { documentId, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { documentId, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeAttachedDocumentRequested]: handleRequest,
    [events.removeAttachedDocumentSucceeded]: handleSuccess,
    [events.removeAttachedDocumentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
